export default {"src":"/_next/static/media/paypal.56b6f396.svg","height":20,"width":76,"blurWidth":0,"blurHeight":0};